var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c(_vm.componentTag,_vm._g({tag:"component",staticClass:"cms-link",attrs:{"id":_vm.link.customId,"to":_vm.to,"href":_vm.href,"target":_vm.target},on:{"click":_vm.onClick}},_vm.$listeners),[_vm._t("before"),_vm._t("default"),_vm._t("after")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }